import React from 'react';
import { VrNetworkList } from '@/utils/api/fetchVrNetwork';
import TickInCircle from '../icons/TickInCircle';
const FarmerCard = React.memo(({
  item,
  isSelected,
  onSelect,
  gradient,
  isLastItem
}: {
  item: VrNetworkList;
  isSelected: boolean;
  onSelect: (item: VrNetworkList) => void;
  gradient: string;
  isLastItem: boolean;
}) => {
  return <button key={item.id} className={`farmer-card flex justify-between items-center bg-white px-4 py-2 border rounded-xl ${isSelected ? 'border-neutral-90' : 'border-neutral-30 '} ${isLastItem ? 'mb-20' : null}`} onClick={() => onSelect(item)}>
        <div className="flex items-center gap-4">
          <p className="flex justify-center items-center rounded-full w-12 h-12 font-medium text-white text-xl" style={{
        backgroundImage: gradient
      }}>
            {item.full_name?.charAt(0).toUpperCase()}
          </p>
          <div>
            <p className="font-medium text-neutral-100 text-lg text-start">
              {item.full_name || '--'}
            </p>
            <p className="font-normal text-neutral-80 text-sm text-start">
              {item.profile?.village || '--'}
            </p>
            <p className="font-medium text-neutral-80 text-sm text-start">
              {item.phone_number}
            </p>
          </div>
        </div>
        <TickInCircle width={28} height={28} isSelected={Boolean(isSelected)} />
      </button>;
});
export default FarmerCard;